import React from 'react'

// Components
import { PillAdminVariant } from '@sketch/components'

// Styles
import { Pill, GuestBadge } from './MemberRow/MemberRow.styles'

// Types
import { BadgeForMemberRoleProps } from './types'
import { ShareMembershipInfoFragment } from '@sketch/gql-types'

export const badgeForMemberRole = ({
  role,
  inviteStatus = null,
}: BadgeForMemberRoleProps) => {
  switch (inviteStatus) {
    case 'INVITED':
      return (
        <Pill role="status-badge" color="gray" variant={{ kind: 'secondary' }}>
          Invitation Pending
        </Pill>
      )
    case 'REQUESTED':
      switch (role) {
        case 'MEMBER':
          return null
        default:
          return <GuestBadge role="status-badge">Guest</GuestBadge>
      }
    case 'ACCEPTED':
      switch (role) {
        case 'ADMIN':
          return (
            <Pill role="status-badge" color="indigo" variant={PillAdminVariant}>
              Admin
            </Pill>
          )
        case 'GUEST':
          return <GuestBadge role="status-badge">Guest</GuestBadge>
        case 'MEMBER':
          return null
      }
      return <GuestBadge role="status-badge">Guest</GuestBadge>
    default:
      return null
  }
}

export const isInvitationRequested = (
  inviteStatus: ShareMembershipInfoFragment['inviteStatus']
) => inviteStatus === 'REQUESTED' || inviteStatus === 'INVITED'
